import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
    `<div>
  <h4>Description - Spill</h4>
  <p>
      Spillage was reported by one of the Associates, who asked for help.
  </p>
  <h4>Impact</h4>
  <p>
      Spillages entail risks of slips, chemical exposure, environmental harm, and fire hazards.
  </p>
  <h4>Resolution Steps</h4>
  <p>
      1. Locate the Stow Associate who requested help.<br />
      2. Confirm the type of spillage, prevent Hazmat risk:
      <ul>
            <li> If a package has a Hazmat label and there is a spill, then instruct Hazmat Associate to wear full PPE and use a spill kit to contain the spill.</li>
            <li> If content is unidentified, then instruct Hazmat Associate to wear non-vented goggles, chemical resistant gloves, mask, and apron before beginning to identify the spill [FA2].</li>
            <li> Ensure responding associates are trained and are following standard work around Hazmat cleanup and disposal.</li>
      </ul>
      3. Resolution:
      <ul>
            <li> HazMat product: refer to Hazmat Clean up & Disposal and Hazardous Waste & Spill Management SOP</li>
            <li> Non HazMat product: refer to Problem Solve Repack SOP</li>
      </ul> 
      4. After following required steps, complete this work item in SCC.
  </p>
</div>
`
);



// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_Help_Request_Spill.jsx